import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import AppShell from './app/AppShell';
import {
  PUBLIC_MIN_FREQUENCY,
  PUBLIC_MAX_FREQUENCY,
  isFrequencyWithinRange,
} from './constants/frequencies';
import './styles.css';
import './styles/legal.css';

const container = document.getElementById('root');
const root = createRoot(container);

const isFrequencyAllowed = (frequency) =>
  isFrequencyWithinRange(frequency, PUBLIC_MIN_FREQUENCY, PUBLIC_MAX_FREQUENCY);

const featureConfigValue = {
  isFrequencyPlayable: isFrequencyAllowed,
  isFrequencyInteractable: isFrequencyAllowed,
  canEditScenario: false,
};

root.render(
  <StrictMode>
    <AppShell featureConfigValue={featureConfigValue} />
  </StrictMode>
);


